/**
 * Configuration des icônes et du type (réseau social ou non) pour les moyens de communication.
 * N/A = pas d'icône → le moyen n'est pas affiché.
 * Aligné sur la table moyencommunicationtype et la spec (Bold / …).
 */
import { MoyenCommunicationType } from "../types/apidae.d";

export type MoyenCommunicationIconConfig = {
  icon: string | null; // null = N/A, ne pas afficher
  isSocial: boolean;
};

export const MOYEN_COMMUNICATION_ICON_CONFIG: Record<
  string,
  MoyenCommunicationIconConfig
> = {
  [MoyenCommunicationType.TELEPHONE]: {
    icon: "bold/call/phone_rounded",
    isSocial: false,
  },
  [MoyenCommunicationType.MAIL]: {
    icon: "bold/messages_conversation/letter",
    isSocial: false,
  },
  [MoyenCommunicationType.SITE_WEB]: {
    icon: "bold/map_&_location/global",
    isSocial: false,
  },
  [MoyenCommunicationType.SITE_INTERNET_MOBILE]: {
    icon: null,
    isSocial: false,
  },
  [MoyenCommunicationType.FAX]: { icon: null, isSocial: false },
  [MoyenCommunicationType.TELEPHONE_FAX]: { icon: null, isSocial: false },
  [MoyenCommunicationType.FACEBOOK]: {
    icon: "bold/social_media/facebook",
    isSocial: true,
  },
  [MoyenCommunicationType.GOOGLE_PLUS]: {
    icon: "bold/social_media/google",
    isSocial: true,
  },
  [MoyenCommunicationType.TWITTER]: {
    icon: "bold/social_media/x",
    isSocial: true,
  },
  [MoyenCommunicationType.TRIPADVISOR]: {
    icon: "bold/social_media/tripadvisor",
    isSocial: true,
  },
  [MoyenCommunicationType.YELP]: {
    icon: "bold/social_media/yelp",
    isSocial: true,
  },
  [MoyenCommunicationType.MINITEL]: { icon: null, isSocial: false },
  [MoyenCommunicationType.SHORTY_URL]: { icon: null, isSocial: false },
  [MoyenCommunicationType.TIKTOK]: {
    icon: "bold/social_media/tiktok",
    isSocial: true,
  },
  [MoyenCommunicationType.LINKEDIN]: {
    icon: "bold/social_media/linkedin",
    isSocial: true,
  },
  [MoyenCommunicationType.CHAINE_YOUTUBE]: {
    icon: "bold/social_media/youtube",
    isSocial: true,
  },
  [MoyenCommunicationType.CHAINE_DAILYMOTION]: {
    icon: "bold/social_media/dailymotion",
    isSocial: true,
  },
  [MoyenCommunicationType.VIMEO]: {
    icon: "bold/social_media/vimeo",
    isSocial: true,
  },
  [MoyenCommunicationType.GALERIE_FLICKR]: {
    icon: "bold/social_media/flickr",
    isSocial: true,
  },
  [MoyenCommunicationType.INSTAGRAM]: {
    icon: "bold/social_media/instagram",
    isSocial: true,
  },
  [MoyenCommunicationType.PINTEREST]: {
    icon: "bold/social_media/pinterest",
    isSocial: true,
  },
  [MoyenCommunicationType.SNAPCHAT]: {
    icon: "bold/social_media/snapchat",
    isSocial: true,
  },
};

/** Mapping id (table moyencommunicationtype) → enumKey pour fallback quand l'API ne renvoie pas enumKey */
const MOYEN_COMMUNICATION_ID_TO_ENUMKEY: Record<number, string> = {
  201: MoyenCommunicationType.TELEPHONE,
  204: MoyenCommunicationType.MAIL,
  205: MoyenCommunicationType.SITE_WEB,
  3769: MoyenCommunicationType.SITE_INTERNET_MOBILE,
  202: MoyenCommunicationType.FAX,
  206: MoyenCommunicationType.TELEPHONE_FAX,
  207: MoyenCommunicationType.FACEBOOK,
  7166: MoyenCommunicationType.LINKEDIN,
  7217: MoyenCommunicationType.CHAINE_YOUTUBE,
  7218: MoyenCommunicationType.CHAINE_DAILYMOTION,
  7219: MoyenCommunicationType.VIMEO,
  7220: MoyenCommunicationType.GALERIE_FLICKR,
  7221: MoyenCommunicationType.INSTAGRAM,
  7222: MoyenCommunicationType.PINTEREST,
  7223: MoyenCommunicationType.SNAPCHAT,
  3789: MoyenCommunicationType.GOOGLE_PLUS,
  3755: MoyenCommunicationType.TWITTER,
  4000: MoyenCommunicationType.TRIPADVISOR,
  4007: MoyenCommunicationType.YELP,
  203: MoyenCommunicationType.MINITEL,
  4923: MoyenCommunicationType.SHORTY_URL,
  6915: MoyenCommunicationType.TIKTOK,
};

/**
 * Retourne la config pour un enumKey ; si absent ou N/A, null.
 */
export function getMoyenCommunicationConfig(
  enumKey: string | undefined,
): MoyenCommunicationIconConfig | null {
  if (!enumKey) return null;
  const config = MOYEN_COMMUNICATION_ICON_CONFIG[enumKey];
  if (!config || config.icon === null) return null;
  return config;
}

/**
 * Retourne la config à partir de l'id du type (quand l'API ne renvoie pas enumKey).
 */
export function getMoyenCommunicationConfigById(
  typeId: number | undefined,
): MoyenCommunicationIconConfig | null {
  if (typeId == null) return null;
  const enumKey = MOYEN_COMMUNICATION_ID_TO_ENUMKEY[typeId];
  return enumKey ? getMoyenCommunicationConfig(enumKey) : null;
}
